import { ArrowLeft } from 'lucide-react';
import { useSmartBack } from '../../hooks/useSmartBack';

interface BackButtonProps {
  /** Route used when there is no history to pop (deep link, refresh, redirect). */
  fallback?: string;
  className?: string;
  iconClassName?: string;
  label?: string;
}

export function BackButton({
  fallback,
  className = 'p-2 -ml-2 hover:bg-gray-100 rounded-full transition-colors',
  iconClassName = 'h-6 w-6 text-heading',
  label = 'Go back',
}: BackButtonProps) {
  const goBack = useSmartBack(fallback);

  return (
    <button onClick={goBack} className={className} aria-label={label} title={label}>
      <ArrowLeft className={iconClassName} />
    </button>
  );
}
